import styled from "styled-components";
import { actionBarButtonItemStyle } from "./ActionBar.style";
import Button from "../button/Button";
import { StyledIcon } from "../menu/ActionMenuItem.style";
export const StyledActionBarButton = styled(Button).withConfig({ displayName: "StyledActionBarButton_APC-7311-productShell", componentId: "sc-1564n7p" })(({ theme }) => ({
    "&&": Object.assign(Object.assign({}, actionBarButtonItemStyle({ theme })), { border: "none !important", [`& ${StyledIcon}`]: {
            color: theme.colors.apolloColorTextPopoverPrimary,
        } }),
    "& > span": {
        display: "flex",
        alignItems: "center",
    },
}));
//# sourceMappingURL=ActionBarButton.style.js.map